module.exports = __webpack_public_path__ + "img/up_05.eaa58085.png";